export default __webpack_public_path__ + "static/media/rain-2.3473cbfa.png";